import React from "react";
import { KPMGLogoutConfirmIcon } from "../../../assets/icons";
import ModalIds from "../../../constants/modalIds";
import Color from "../../../enums/color";
import InfoModal from "../modal/InfoModal";
import { getAuthentication } from "../../../services/authentication/authenticationHelpers";
const LogoutConfirmModalContainer = () => {
    const handleOk = () => { var _a; return (_a = getAuthentication()) === null || _a === void 0 ? void 0 : _a.requestLogOut(); };
    return (<InfoModal id={ModalIds.LOGOUT_CONFIRM} icon={<KPMGLogoutConfirmIcon />} title="LOGOUT_CONFIRM.MODAL.TITLE" colorTheme={Color.CuriousBlue} okButtonProps={{
            name: "DISCONNECT",
            onClick: handleOk
        }}/>);
};
export default LogoutConfirmModalContainer;
